// extracted by mini-css-extract-plugin
module.exports = {"containerQRCode":"AnalysisQRCode_containerQRCode__wsC3K","qrcode":"AnalysisQRCode_qrcode__3_NFB","pin":"AnalysisQRCode_pin__3mGGy"};